<template>
  <div class="text-left">
    <h4 class="mb-8 mt-4 text-left text-dark-gray sm:mt-2">
      Enter your Comchek payment information.
    </h4>
    <div class="sm:mt-2 sm:flex sm:gap-6">
      <div class="w-full">
        <form-field
          id="email"
          label="Email"
          :value="email"
          placeholder="Enter your email address"
          :on-input="handleEmailAddress"
          name="email"
          pattern="\d*"
        />
        <p
          v-if="data.errors"
          class="-mt-3 mb-2 text-3xs text-red-500 sm:hidden"
        >
          Account numbers do not match
        </p>
      </div>
    </div>
    <p
      v-if="data.errors"
      class="-mt-3 hidden text-3xs text-red-500 sm:block"
    >
      Account numbers do not match
    </p>
  </div>
</template>
<script>
import FormField from '../../FormField.vue';
import { isEmail } from '@/common/validators.js';
export default {
  name: 'Comcheck',
  components: {
    'form-field': FormField,
  },
  props: {
    data: Object,
    firstTime: {
      type: [Number, Boolean],
      required: true,
    },
    stepName: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      email: '',
    };
  },
  computed: {
    isValidForm: function () {
      return this.isValidEmailAddress();
    },
    newPaymentMethodType() {
      return this.$store.state.payments?.newPaymentMethodType;
    },
  },
  watch: {
    isValidForm: function (isValid) {
      this.$store.commit('toggleDisabledButton', {
        bool: !isValid,
        source: 'Payment-3 Comcheck #5',
      });
    },
    stepName: function (val) {
      // if (val === "Payment-3" && !this.firstTime) {
      if (
        val === 'Payment-3' &&
        ['comcheck', 'comchek'].includes(this.newPaymentMethodType)
      ) {
        if (this.email?.length > 0) {
          this.onUpdate();
        } else {
          this.toggleButton(true);
        }
      }
    },
  },
  mounted() {
    this.$store.commit(
      'addFormDebugMessage',
      'Payment-3 | Comcheck | Comcheck mounted'
    );
    if (!this.isValidForm) {
      this.$store.commit('toggleDisabledButton', {
        bool: true,
        source: 'Payment-3 Comcheck #1',
      });
    } else {
      this.$store.commit('toggleDisabledButton', {
        bool: false,
        source: 'Payment-3 Comcheck #2',
      });
    }
  },
  methods: {
    isValidEmailAddress() {
      return isEmail(this.email);
    },
    handleEmailAddress(e) {
      this.email = e.target.value;
      if (!isEmail(this.email))
        this.$store.commit('toggleDisabledButton', {
          bool: true,
          source: 'Payment-3 Comcheck #3',
        });
      this.onUpdate();
    },

    onUpdate() {
      let body = {
        is_active: true,
        email_address: this.email,
        is_type: this.$store.state.payments.newPaymentMethodType,
      };
      this.updateOnboardingPacket(body);
    },
    toggleButton(value) {
      this.$store.commit('toggleDisabledButton', {
        bool: value,
        source: 'Payment-3 Comcheck #4',
      });
    },
    updateOnboardingPacket(body) {
      this.$store.dispatch('payments/setPaymentBody', {
        payment_method: body,
      });
    },
  },
};
</script>
